import { render, staticRenderFns } from "./patient-queue.vue?vue&type=template&id=1ad1f5a1&"
import script from "./patient-queue.vue?vue&type=script&lang=js&"
export * from "./patient-queue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports